
import { useEffect, useMemo } from 'react';
import { usePagination } from '@/hooks/use-pagination';
import { CountryItem } from '../types';

export const useCountriesPagination = (
  filteredCountries: CountryItem[],
  searchQuery: string,
  selectedRegion: string | null,
  selectedStatus: string | null
) => {
  // Pagination state
  const {
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage
  } = usePagination({ itemsPerPage: 10 });

  // Calculate pagination values based on filtered results
  const totalItems = filteredCountries.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  
  // Get paginated countries from filtered results
  const paginatedCountries = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredCountries.slice(startIndex, endIndex);
  }, [filteredCountries, currentPage, itemsPerPage]);

  // Reset to first page when filters change
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(1);
    }
  }, [totalPages, currentPage, setCurrentPage]);

  // Reset to first page when search or filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, selectedRegion, selectedStatus, setCurrentPage]);

  return {
    paginatedCountries,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalItems,
    totalPages
  };
};
